import Env from '@/helpers/Env';
import { useMemo } from 'react';

export const MobileDistance = ({ children, distance = 0, ...props }) => {
  const z = useMemo(() => (Env.mobile ? distance : 0), [distance]);

  return <group position={[0, 0, z]}>{children}</group>;
};
